import React from "react";
import style from "./index.module.scss";

interface ItemStatusProps {
    status: "todo" | "done";
}

export default function ItemStatus({ status }: ItemStatusProps) {
    if (status === "todo") {
        return <span className={style.todo}>未学习</span>;
    }

    return <span className={style.done}>已学习</span>;
}
